
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/time-saving-tips-getting-most-from-delayedsend-microsoft-teams",
      function () {
        return require("private-next-pages/article/time-saving-tips-getting-most-from-delayedsend-microsoft-teams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/time-saving-tips-getting-most-from-delayedsend-microsoft-teams"])
      });
    }
  